// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.creditkey-offer .custom-radio-group .MuiFormGroup-root{flex-wrap:wrap}`, "",{"version":3,"sources":["webpack://./src/containers/MultistepForm/Step3/CreditkeyOffer/styles.scss"],"names":[],"mappings":"AACE,wDACE,cAAA","sourcesContent":[".creditkey-offer {\n  .custom-radio-group .MuiFormGroup-root {\n    flex-wrap: wrap;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
